import WoodDetail from "../components/WoodDetail";

function WoodPage(props) {
  return (
    <div>
        <WoodDetail />
    </div>
  );
}
export default WoodPage;
